// extracted by mini-css-extract-plugin
export default {"noSpaces":"spaces_noSpaces__mASB1"};